import React, { useEffect } from 'react'
import { useTranslation } from 'next-i18next'
import {
  Box,
  Button,
  IconFilter,
  IconList,
  IconMapMarkerAlt
} from '@machobear/design-system'

import useFilterLabels from '@/features/Listings/hooks/use-filter-labels'
import { useFiltersModal } from '@/features/Listings/hooks/use-filters-modal'

import { useMapList } from '../maplist-context'

const Actions = ({ boundaries = {}, centerPoint, filters }) => {
  const { t } = useTranslation()
  const { setListState, isListVisible, setHiddenSearch, listWrapperRef } =
    useMapList()
  const isUniversityPage =
    window.location.href.includes('offcampushousing') ||
    window.location.href.includes('och-dev.machobear.ca') ||
    window.location.href.includes('offcampus-housing.com')

  const [getFilterLabels] = useFilterLabels()
  const filterList = getFilterLabels(filters)

  // Exclude the Suggested sort from the count since it's the default sort
  const activeFilterCount = filterList?.filter(
    item => !(item.id === 'sort' && item.label === 'Suggested')
  )?.length

  const filterIds = filterList
    ?.map(({ id }) => id)
    .sort()
    .join(',')

  useEffect(() => {
    if (listWrapperRef.current) {
      listWrapperRef.current.scrollTop = 0
    }
  }, [filterIds])

  const [showFiltersModal] = useFiltersModal({
    isMapMode: true,
    isUniversityPage,
    boundaries,
    centerPoint
  })

  const clickId = 'map-filters-open-click'
  const handleFiltersClick = () => {
    window.dataLayer.push({
      event: clickId
    })
    showFiltersModal()
  }

  return (
    <Box
      paddingX="small"
      paddingY="xxsmall"
      background="white"
      borderBottom={activeFilterCount >= 1 ? null : 'borderNeutralLight'}
      display="flex"
      alignItems="center"
      justifyContent="spaceBetween"
      gap="xxsmall"
    >
      {isListVisible ? (
        <Button
          variant="soft"
          icon={<IconMapMarkerAlt />}
          onClick={() => {
            setHiddenSearch(false)
            setListState(false)
          }}
          tone={!isListVisible ? undefined : 'neutral'}
          id={
            isListVisible
              ? 'city-page-map-click'
              : 'city-page-map-view-map-click'
          }
        >
          {t('Map View')}
        </Button>
      ) : (
        <Button
          variant="soft"
          icon={<IconList />}
          onClick={() => setListState(true)}
          tone={isListVisible ? undefined : 'neutral'}
          id={
            isListVisible
              ? 'city-page-list-click'
              : 'city-page-map-view-list-click'
          }
        >
          {t('List View')}
        </Button>
      )}
      <Button
        variant="soft"
        icon={<IconFilter />}
        onClick={handleFiltersClick}
        id={
          isListVisible
            ? 'city-page-filters-open-click'
            : 'city-page-map-view-filters-open-click'
        }
        tone="neutral"
      >
        {t('filters:b.listing_filter.edit.filters.label', 'Filters')}{' '}
        {activeFilterCount >= 1 ? `(${activeFilterCount})` : null}
      </Button>
    </Box>
  )
}

export { Actions }
